module.exports = __webpack_public_path__ + "img/wx.1037a94d.png";